// @flow
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import useNetwork from '../../hooks/useNetwork';
import NoWiFi from '../Icons/NoWiFi';

const useStyles = makeStyles(theme => ({
  wrapper: {
    left: '0',
    height: '60px',
    width: '100%',
    zIndex: 999999,
    backgroundColor: '#dadce0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > span': {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
      lineHeight: '31px',
      margin: '0 16px',
      color: '#000',
    },

    '& > button': {
      borderRadius: '50px',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '20px',
      lineHeight: '26px',
      padding: '8px 24px',
      border: `1px solid ${theme.palette.ava.blue}`,
      color: theme.palette.ava.blue,
    },
  },
}));

function Status({ isInConversation }: { isInConversation: Boolean }) {
  const online = useNetwork();
  const { t } = useTranslation();
  const classes = useStyles();

  const handleReconnect = () => {
    window.location.reload();
  };

  if (online || isInConversation) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <NoWiFi />
      <span>{t('network.currentlyOffline')}</span>
      {!window.isElectron && <Button onClick={handleReconnect}>{t('network.tryToReconnect')}</Button>}
    </div>
  );
}

const mapStateToProps = ({ scribeConversation: { isInConversation } }) => ({
  isInConversation,
});
// $FlowFixMe
export default connect(mapStateToProps, {})(Status);
